<template>
  <div>
    <div class="Link">
      <router-link to="/about" class="a">
        <div class="li">
          <el-image class="img" :src="about" fit="fill"></el-image>
          <br />
          <span>关于我们</span>
        </div>
      </router-link>
      <router-link to="/news" class="a">
        <div class="li">
          <el-image class="img" :src="news" fit="fill"></el-image>
          <br />
          <span>新闻资讯</span>
        </div>
      </router-link>
      <router-link to="/join" class="a">
        <div class="li">
          <el-image class="img" :src="join" fit="fill"></el-image>
          <br />
          <span>加入我们</span>
        </div>
      </router-link>
      <router-link to="investor" class="a">
        <div class="li">
          <el-image class="img" :src="investment" fit="fill"></el-image>
          <br />
          <span>投资者关系</span>
        </div>
      </router-link>
    </div>
  </div>
</template>
<script>
import api from '@/utils/api'
import about from '@/assets/img/about.png'
import news from '@/assets/img/news.png'
import join from '@/assets/img/join.png'
import investment from '@/assets/img/investment.png'
export default {
  name: 'Link',
  data() {
    return {
      about: about,
      news: news,
      join: join,
      investment: investment,
    }
  },
  methods: {
    ToAbout() {},
  },
}
</script>
<style scoped>
/* link链接的设置 */
.a {
  color: #666666;
  text-decoration: none;
}
.Link{
  height: 1rem;
}
.li {
  display: block;
  float: left;
  width: 10rem;
  height: 7.5rem;
  font-size: 1.5rem;
  text-align: center;
  list-style-type: none;
  width: 25%;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.img {
  width: 5rem;
  height: 5rem;
  margin-right: 0.4375rem;
}
</style>
